import { Suspense } from 'react';
import { Outlet, useRoutes } from 'react-router-dom';

import { lazyRetry } from 'src/utils/lazyRetry';
import { SplashScreen } from 'src/components/loading-screen';
import { LPAuthGuard } from 'src/auth/guard';

const LPLoginPage = lazyRetry(() => import('src/pages/LP/LPLogin'));

// const LPVerifyTocPage = lazyRetry(() => import('src/pages/LP/LPVerifyToc'));

const LPForgetPasswordPage = lazyRetry(() => import('src/pages/LP/LPForgetPassword'));

const LPDashboardPage = lazyRetry(() => import('src/pages/LP/LPDashboard'));

const LPSignupPage = lazyRetry(() => import('src/pages/LP/LPSignup'));

export default function LiquidityProviderRoutesLazy() {
  return useRoutes([
    {
      element: (
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      ),
      children: [
        {
          path: '',
          element: <LPLoginPage />,
        },
        {
          path: 'login',
          element: <LPLoginPage />,
        },

        // {
        //   path: 'verify-toc',
        //   element: <LPVerifyTocPage />,
        // },
        {
          path: 'forget-password',
          element: <LPForgetPasswordPage />,
        },
        {
          path: 'signup',
          element: <LPSignupPage />,
        },
        {
          path: 'dashboard',
          element: (
            <LPAuthGuard>
              <LPDashboardPage />
            </LPAuthGuard>
          ),
        },
      ],
    },
  ]);
}
